<script>
export default {
  name: 'ButtonControl',
  props: {
    name: {
      type: String,
      required: true,
    },
    buttons: {
      type: Array,
      required: true,
    },
    active: {
      type: String,
      default: '',
    },
  },
  data: function() {
    return {
      uid: 0,
    };
  },
  mounted() {
    this.uid = `${this.name}${this._uid}`;
  },
  methods: {
    activeClass: function(value) {
      return this.active === value ? 'button_control__container-active' : '';
    },
  },
};
</script>

<template>
  <div class="button_control__group">
    <div
      v-for="button in buttons"
      :key="button.value"
      :class="['button_control__container', activeClass(button.value)]"
    >
      <input
        :id="uid"
        :name="name"
        :value="button.value"
        :selected="button.value === active"
        type="radio"
        @click="$emit('input', button.value)"
      >
      <div class="button_control__button">
        <label :for="uid + button.value">{{ button.label }}</label>
      </div>
    </div>
  </div>
</template>
